import { Box, Typography, useTheme } from '@mui/material';
import { formatDollarAmount } from '../../utils/global/helper';

export default function CustomTooltip({
  active,
  payload,
  chartTitle,
  dataKey,
  type,
  xAxisKey,
}: any) {
  const theme = useTheme();
  if (active && payload && payload.length) {
    const entry = payload[0].payload;
    const segmentColor = payload[0].color; // Extracting the color

    // Convert dataKey to Title Case
    const toTitleCase = (str: string) =>
      str.replace(
        /\w\S*/g,
        txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
      );

    return (
      <div
        style={{
          backgroundColor: '#FFF',
          padding: '10px',
          borderRadius: '5px',
          border: '1px solid #f5f5f5',
          boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
        }}>
        <Typography
          variant="h5"
          style={{
            borderBottomWidth: 1,
            borderBottomStyle: 'solid',
            borderBottomColor: theme.palette.outlineGrey.main,
          }}>
          {chartTitle}
        </Typography>
        <Box display="flex" alignItems="center" marginTop={1}>
          {segmentColor && (
            <Box
              width={8}
              height={8}
              borderRadius="50%"
              bgcolor={segmentColor}
              marginRight={0.5}
            />
          )}
          <Typography
            style={{ flexGrow: 1, marginRight: 20 }}
            variant="caption">
            {toTitleCase(entry[xAxisKey])}
          </Typography>
          <Typography variant="caption">
            {type === 'dollar'
              ? formatDollarAmount(entry[dataKey])
              : entry[dataKey]}
          </Typography>
        </Box>
      </div>
    );
  }

  return null;
}
